/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Ajay Patidar's Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Ajay Patidar Portfolio",
    type: "website",
    url: "#",
  },
};


//---------------------------------------------------------------------HOME HEADER -------------------------------------------------------------------




//Home Page
const greeting = {
  title: "Ajay Patidar",
  logo_name: "Ajay Patidar",
 // nickname: " ", //for nick name
  subTitle:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  resumeLink:
    "https://drive.google.com/file/d/1FL_wydnPF2SWCdw2goYAgZ1KKBx8TpcD/view?usp=sharing",     // google dricve link for resume
  portfolio_repository: "https://github.com/Ajay-Patidar-8085",                    // github  repo link
  githubProfile: "https://github.com/Ajay-Patidar-8085",                                           //  github   link
};




//----------------------------------------------------social link ---------------------------------------------------------------------



const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/Ajay-Patidar-8085 ",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/ajaypatidar8085/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
 /* {
    name: "YouTube",
    link: "https://youtube.com/c/DevSense19",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  }, */
  {
    name: "Gmail",
    link: "mailto:ajpatdar.8085+github@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
 /* {
    name: "X-Twitter",
    link: "https://twitter.com/ashutosh_1919",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/laymanbrother.19/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/layman_brother/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  }, */
];




//-------------------------------------------------Skills-----------------------------------------------------------------------------------



const skills = {
  data: [
   

//-------------------------------------------------------FULL STACK WEB ------------------------------------------------------------


{

      title: "Web Development",
      fileName: "FullStackImg",
      skills: [
        "⚡Knowledge of HTML and CSS.",
        "⚡ Knowledge of web technologies JAVASCRIPT.",
        "⚡Knowledge of web technologies REACT.",
        "⚡Good Knowledge of MYSQL DATABASE.",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
            
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
       
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },

        {
          skillName: "MY SQL",
          fontAwesomeClassname: "logos:mysql",
          style: {
            color: "#61DAFB",
           // width : "px" ,
            height : "50px",
          },
        },

        
    {
      skillName: "",
      fontAwesomeClassname: "fa-brands:elementor",
      style: {
        backgroundColor: "transparent",

        color: "transparent" ,

        width :"55PX",
         height:"60PX" ,
      },
    },
    {
      skillName: "",
      fontAwesomeClassname: "fa-brands:elementor",
      style: {
        backgroundColor: "transparent",

        color: "transparent" ,

        width :"55PX",
         height:"60PX" ,
      },
    },
    {
      skillName: "",
      fontAwesomeClassname: "fa-brands:elementor",
      style: {
        backgroundColor: "transparent",

        color: "transparent" ,

        width :"PX",
         height:"PX" ,
      },
    },
    {
      skillName: "",
      fontAwesomeClassname: "fa-brands:elementor",
      style: {
        backgroundColor: "transparent",

        color: "transparent" ,

        width :"PX",
         height:"PX" ,
      },
    },

/*

 {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },


        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Gatsby",
          fontAwesomeClassname: "simple-icons:gatsby",
          style: {
            color: "#663399",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
*/



      ],
    },


//------------------------------------------------------------CLOUD COMPUTING-----------------------------------------------------------------




 /*   {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Deploying deep learning models on cloud to use on mobile devices",
        "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },


    */



//--------------------------------------------UI /UX DESIGN------------------------------------------------------------

/*

    {
      title: "Php & Wordpress Development",
      fileName: "DesignImg",
      skills: [
        "⚡ Developing website using Wordpress",
        "⚡ Customizing and creating custom webpages using Elementor",
        "⚡ Good knowledge of PHP",
      ],
      softwareSkills: [
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF7C00",
          },
        },
        {
          skillName: "Inkscape",
          fontAwesomeClassname: "simple-icons:inkscape",
          style: {
            color: "#000000",
          },
        },
      ],
    },

    */
//----------------------------------------------------------------------------------------------------------------------------


//----------------------------------------------data science -------------------------------------------------------------------
{

  title: "Php & Wordpress Development",
  fileName: "DataScienceImg",
  skills: [
    "⚡ Developing website using Wordpress.",
    "⚡ Customizing and creating custom webpages using Elementor.",
    "⚡ Good knowledge of PHP.",

  ],
  
  softwareSkills: [
    {
      skillName: "PHP",
      fontAwesomeClassname: "logos:php" ,
      style: {
        backgroundColor: "transparent",
        height:"50PX" ,
      },
    },
    {
      skillName: "Wordpress",
      fontAwesomeClassname: "skill-icons:wordpress",
      style: {
        backgroundColor: "transperent",
        color: "#D00000",
        height:"55PX",
        width : "65px",
         
      },
    },
    {
      skillName: "ELEMENTOR",
      fontAwesomeClassname: "fa-brands:elementor",
      style: {
        backgroundColor: "transparent",

        color: "#9826ab" ,

        width :"55PX",
         height:"60PX" ,
      },
    },
    {
      skillName: "",
      fontAwesomeClassname: "fa-brands:elementor",
      style: {
        backgroundColor: "transparent",

        color: "transparent" ,

        width :"55PX",
         height:"60PX" ,
      },
    },
    {
      skillName: "",
      fontAwesomeClassname: "fa-brands:elementor",
      style: {
        backgroundColor: "transparent",

        color: "transparent" ,

        width :"55PX",
         height:"60PX" ,
      },
    },
    {
      skillName: "",
      fontAwesomeClassname: "fa-brands:elementor",
      style: {
        backgroundColor: "transparent",

        color: "transparent" ,

        width :"55PX",
         height:"60PX" ,
      },
    },
    {
      skillName: "",
      fontAwesomeClassname: "fa-brands:elementor",
      style: {
        backgroundColor: "transparent",

        color: "transparent" ,

        width :"55PX",
         height:"60PX" ,
      },
    },
    {
      skillName: "",
      fontAwesomeClassname: "fa-brands:elementor",
      style: {
        backgroundColor: "transparent",

        color: "transparent" ,

        width :"PX",
         height:"PX" ,
      },
    },
   /* {
      skillName: "Python",
      fontAwesomeClassname: "ion-logo-python",
      style: {
        backgroundColor: "transparent",
        color: "#3776AB",
      },
    },
    {
      skillName: "Deeplearning",
      imageSrc: "deeplearning_ai_logo.png",
    }, */
  ],
},










  




//------------------------------------ skill sections closing----------------------------------------------------------------
  ],
};




//-------------------------------------------------------------EDUCATION PAGE-----------------------------------------------------




// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Coding Ninja",
      iconifyClassname: "simple-icons:codingninjas",
      style: {
        color:   "#f96b24 "   ,       // "#F79F1B",   
      },
      profileLink: "https://www.codingninjas.com/studio/profile/98481c05-0265-4ce3-a4fc-3e369add7d7c",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/profile/ajpatidar_8085",
    },
    {
      siteName: "Coursera",
      iconifyClassname: "cib:coursera",
      style: {
        color: "#0056D2",
      },
      profileLink: "#",
    },

    /*
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com/profile/layman_brother",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@ashutosh391",
    }, */
    /*{
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/laymanbrother",
    },    */
  ],
};


//---------------------------------------------------------------degree rtecived --------------------------------------------




const degrees = {
  degrees: [
    {
      title: "Sage University,INDORE",
      subtitle: "Master of Computer Application",
      logo_path: "logo-sage.png",
      alt_name: "SAGE UNIVERSITY",
      duration: "2021 - 2023",
      descriptions: [
        "⚡ I have done my post-graduation from SAGE UNIVERSITY INDORE.",
      ],    
    
    },
    {
      title: "Devi Ahilya Vishwavidyalaya,INDORE",
      subtitle: "BSc in Computer Science",
      logo_path: "logo-davv.png",
      alt_name: "DAVV",
      duration: "2017 - 2020",
      descriptions: [
        "⚡ I have done my Bachelor's degree from DAVV INDORE.",
        
      ],
   
    },
  ],
};



//----------------------------------------------------CERTIFICATIONS ------------------------------------------------------------------




const certifications = {
  certifications: [


    {
      title: "Programing with Javascript",
      subtitle: "- META",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://coursera.org/share/265f263d8047cd7853737a2da6395453",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },


    {
      title: "REACT",
      subtitle: "- META",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/J6FKSENVSYLQ?utm_source=link&utm_medium=certificate&utm_content=cert_image&utm_campaign=sharing_cta&utm_product=course",
      alt_name: "COURSERA",
      color_code: "#2A73CC",
    },
    {
      title: "My SQL",
      subtitle: "- Hackerrank",
      logo_path: "hackerrank-icon.png",
      certificate_link:
        "https://www.hackerrank.com/certificates/1c5ce1168272",
      alt_name: "MYSQL",
      color_code: "#068932",
    },
    {
      title: "Oops in C++",
      subtitle: "- Coding Ninja",
      logo_path: "coding-ninjas-logo-white.png",
      certificate_link:
        "https://files.codingninjas.in/certi_image3677047da1df91cb1a9689dce103b16af3a64f.jpg",
      alt_name: "cn",
      color_code: "#D9DBD4",
    },
   /* {
      title: "Data Science",
      subtitle: "- Alex Aklson",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    
    {
      title: "Big Data",
      subtitle: "- Kim Akers",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },  */

    /*
    {
      title: "Advanced Data Science",
      subtitle: "- Romeo Kienzler",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Advanced ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "DL on Tensorflow",
      subtitle: "- Laurence Moroney",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
   

    /*
    {
      title: "Kuberenetes on GCP",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "Cryptography",
      subtitle: "- Saurabh Mukhopadhyay",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Cloud Architecture",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
      alt_name: "GCP",
      color_code: "#4285F499",
    }, */
  ],
};




// ---------------------------------------------------EXPERIENCE ----------------------------------------------------------------



// Experience Page




  const experience = {
  title: "Experience",
  //subtitle: "Work and Internship ",
  description:
    "Please have look on my work Expirience & Internship.Please scroll for more information.",
  header_image_path: "experience.svg",
  sections: [
  
    {
      title: "Internships",
      work :true ,
      experiences: [
        {
          title: "PHP & WORDPRPESS DEVELOPER",
          company: "Tech Simba Pvt.Ltd.",
          company_url: "",
          logo_path: "INTERNSHIP-LOGO.png",
          duration: "Oct 2023 - Dec 2023",
          location: "Indore, M.P",
          description:
            "Developing website using wordpress and creating custom page using elementor,Customzing website using PHP.",
          color: "#000000",
        },
        
      ],
    
    },

 
    {

      
      title: "Work",
      
       experiences: [
      
       {
         title: "NA",
        company: "",
          company_url: "#",
          logo_path: "INTERNSHIP-LOGO.png",
          duration: "",
          location: "",
         // description:
          // "I have created complete Android Application for locating Pub, Bar and beverage shops around you. I have also worked on implementation of algorithms for Face Detection, Text extraction from Image. I was involved in a team for creating complete software architecure of mobile and web application as well as admin panel for company.",
         color: "#9b1578",
       }  
     
       ],  
    }, 
  ],
};



//------------------------------------------------------------PROJECT PAGE-------------------------------------------------------------------




// Projects Page
const projectsHeader = {
  
  title: "Projects",
 
  description:
  [
    " I've recently finished a project that means a lot to me. It's a mix of creativity and technology. Would you like to take a look? Just click the link below and come check it out! ",
  
   

  

  ],
  description2:
  [
    
    "⚡", <a href= "https://www.ajaypatidar.great-site.net">Portfolio Website</a>

  

  ],
  description3:
  [
    
     "⚡", <a  href= "https://www.dharjobportal.great-site.net" target= "_blank" rel="noreferrer" >Job Portal Website</a > 
  
   

  

  ],
 
 

  avatar_image_path: "projects_image.svg",
  
     

};
 




//--------------------------------------------------CONTACT PAGE---------------------------------------------------------------------------



// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "ajay2.png",
    description:
      "I'm always open to new opportunities and conversations. Let's connect and explore the possibilities together..",
  },
 blogSection: {
    /* title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "#",
    avatar_image_path: "blogs_image.svg", */
  },  
  addressSection: {
    title: "Address",
    subtitle:
      "Vijay Nagar ,Indore M.P (452010)",
    locality: "INDORE",
    country: "IN",
    region: "MADHYA PRADESH",
    postalCode: "452010",
    streetAddress: "VIJAY NAGAR",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/rAmMtEeufWmMN3Gb7",
  },
  phoneSection: {
    title: "Email",
    subtitle: "ajpatidar.8085+github@gmail.com",
  },
};



//-----------------------------------------export property---------------------------------------------------------------------------


export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  
  
  contactPageData,
};
